import axios from 'axios';
import qs from 'qs';
// import formutils from './formutils';
export const baseUrl = window.apiroot;
const dateTimeFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
function reviver(key, value) {
    if (typeof value === 'string' && dateTimeFormat.test(value)) {
        return new Date(value);
    }
    return value;
}
/**
 * Adds a valid CSRF token to any parameters to be sent to a controller.
 *
 * @param params The API call parameters
 * @returns the same parameters enriched with a valid CSRF token
 */
// async function withCsrf(params: Record<string, any>) {
//   const csrf = await api.csrf();
//   params[csrf.tokenName] = csrf.token;
//   return params;
// }
/**
 * Intercept if a request is for a Business Manager Pipeline
 * @param config
 * @returns
 */
function isBmPipeline(config) {
    const BmController = ['BmClothing', 'BmTranslations', 'BmClientService'];
    let controller = config.url.split('-')[0].replace('/', '');
    if (BmController.includes(controller)) {
        return '/on/demandware.store/Sites-Site/default/';
    }
    return config.baseURL;
}
const instance = axios.create({
    baseURL: baseUrl,
    headers: {
        // 'content-type': 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
        'x-requested-with': 'XMLHttpRequest',
        accept: 'application/json',
        device: window.appmode ? 'smartphone' : undefined,
    },
    transformResponse: [
        function transformResponse(data) {
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data, reviver);
                }
                catch (e) {
                    /* Ignore */
                }
            }
            return data;
        },
    ],
    validateStatus: () => true,
});
let numberOfAjaxCAllPending = 0;
instance.interceptors.request.use((config) => {
    config.baseURL = isBmPipeline(config);
    numberOfAjaxCAllPending++;
    document.body.setAttribute('aria-busy', 'true');
    config.paramsSerializer = (params) => qs.stringify(params, {
        arrayFormat: 'repeat',
    });
    return config;
});
instance.interceptors.response.use((response) => {
    numberOfAjaxCAllPending--;
    if (numberOfAjaxCAllPending === 0) {
        document.body.removeAttribute('aria-busy');
    }
    return response;
}, (error) => {
    numberOfAjaxCAllPending--;
    if (numberOfAjaxCAllPending === 0) {
        document.body.removeAttribute('aria-busy');
    }
    return Promise.reject(error);
});
const api = {
    getMenu: async () => {
        return instance.get(`/MenuApi-Menu`).then(({ data }) => {
            return data;
        });
    },
    getFooter: async () => {
        return instance.get(`/FooterApi-Show`).then(({ data }) => {
            return data;
        });
    },
    getPdp: (pid, editiorialPage) => {
        return instance
            .get(`/ProductApi-PDP`, {
            params: {
                pid: pid,
                cid: editiorialPage,
                cachekill: new Date(),
            },
        })
            .then(({ data }) => {
            return data;
        });
    },
};
export default api;
